import moment from 'moment';

export const VueMoment = {
    install(app) {
        const momentInstance = (date) => {
            return moment(date).locale('nl')
        }

        app.provide('$moment', momentInstance)
        app.config.globalProperties.$moment = momentInstance
        app.$moment = momentInstance
    }
}
